module.exports = __webpack_public_path__ + "static/img/aih2.f8fedf7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/aih2.png
// module id = V8Lv
// module chunks = 0